"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossTaskSync = exports.BedroomSync = exports.LocalLicenceSync = void 0;
const React = __importStar(require("react"));
const merlin_hooks_1 = require("@travelnest/merlin-hooks");
const react_redux_1 = require("react-redux");
const types_1 = require("../../entities/fact/types");
const config_1 = require("../../view/pages/tasks/local-licence/config");
const helpers_1 = require("../../hooks/helpers");
const TaskCompletenessContext_1 = require("../../context/TaskCompletenessContext");
const ValidationContext_1 = require("../../context/ValidationContext");
const local_licence_1 = require("../../hooks/validation/local-licence");
/*
    Listener component that will check the current and previous country codes
    if they are changed and decides whether or not we need to change the completeness
    of their local licence information.
*/
const LocalLicenceSync = ({ propertyId }) => {
    const { dispatch: taskCompletenessDispatch } = React.useContext(TaskCompletenessContext_1.TaskCompletenessContext);
    const { dispatch: validationDispatch } = React.useContext(ValidationContext_1.ValidationContext);
    const property = (0, react_redux_1.useSelector)((localLicenceState) => (0, helpers_1.hydratedPropertySelector)(localLicenceState, propertyId));
    const prevCountryCode = (0, merlin_hooks_1.usePrevious)(property === null || property === void 0 ? void 0 : property.country_code);
    React.useEffect(() => {
        if ((property === null || property === void 0 ? void 0 : property.country_code) && prevCountryCode) {
            const needsLicence = !!config_1.LocalLicenceCountries[property.country_code];
            if (!needsLicence) {
                validationDispatch(ValidationContext_1.validationActions.bypassLocalLicence());
            }
            if (needsLicence && property.country_code !== prevCountryCode) {
                const licenceValidation = (0, local_licence_1.validateLocalLicence)(property);
                validationDispatch(ValidationContext_1.validationActions.initialiseLocalLicence(licenceValidation));
                if (licenceValidation.valid) {
                    taskCompletenessDispatch(TaskCompletenessContext_1.taskCompletenessActions.setLocalLicenceCompleteness(types_1.TaskCompletionState.REVIEW_REQUIRED));
                }
                else {
                    taskCompletenessDispatch(TaskCompletenessContext_1.taskCompletenessActions.setLocalLicenceCompleteness(types_1.TaskCompletionState.INPUT_REQUIRED));
                }
            }
            else {
                taskCompletenessDispatch(TaskCompletenessContext_1.taskCompletenessActions.setLocalLicenceCompleteness(types_1.TaskCompletionState.COMPLETE));
            }
        }
    }, [property === null || property === void 0 ? void 0 : property.country_code]);
    return null;
};
exports.LocalLicenceSync = LocalLicenceSync;
/*
    Listener component that will check the current and previous location types
    if they are changed and decides whether or not we need to change the completeness
    of the bedroom information. (As choosing studio property type affects bedroom choices)
*/
const BedroomSync = ({ propertyId }) => {
    const { dispatch } = React.useContext(ValidationContext_1.ValidationContext);
    const property = (0, react_redux_1.useSelector)((bedroomState) => (0, helpers_1.hydratedPropertySelector)(bedroomState, propertyId));
    const prevPropertyType = (0, merlin_hooks_1.usePrevious)(property === null || property === void 0 ? void 0 : property.property_type);
    React.useEffect(() => {
        if ((property === null || property === void 0 ? void 0 : property.property_type) && prevPropertyType) {
            if ((prevPropertyType === 'studio' && property.property_type !== 'studio')
                || (prevPropertyType !== 'studio' && property.property_type === 'studio')) {
                dispatch(ValidationContext_1.validationActions.updateProperty('beds', false));
            }
        }
    }, [property === null || property === void 0 ? void 0 : property.property_type]);
    return null;
};
exports.BedroomSync = BedroomSync;
const CrossTaskSync = ({ propertyId }) => React.createElement(React.Fragment, null,
    React.createElement(exports.LocalLicenceSync, { propertyId: propertyId }),
    React.createElement(exports.BedroomSync, { propertyId: propertyId }));
exports.CrossTaskSync = CrossTaskSync;
//# sourceMappingURL=CrossTaskSync.js.map